import { render, staticRenderFns } from "./RoleAdd.vue?vue&type=template&id=856fb700&scoped=true"
import script from "./RoleAdd.vue?vue&type=script&lang=ts"
export * from "./RoleAdd.vue?vue&type=script&lang=ts"
import style0 from "./RoleAdd.vue?vue&type=style&index=0&id=856fb700&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856fb700",
  null
  
)

export default component.exports